import { createFileRoute } from '@tanstack/react-router';

import { useTelegramBackButton } from '@common/hooks';
import { Page } from '@common/ui/Page';

import { Premium } from '@widgets/premium/Premium';

export const Route = createFileRoute('/premium')({
  component: RouteComponent,
});

function RouteComponent() {
  useTelegramBackButton({ to: 'back' });

  return (
    <>
      <Page>
        <Premium />
      </Page>
    </>
  );
}
